import { render, staticRenderFns } from "./openMore.vue?vue&type=template&id=62940214&scoped=true&"
import script from "./openMore.vue?vue&type=script&lang=js&"
export * from "./openMore.vue?vue&type=script&lang=js&"
import style0 from "./openMore.vue?vue&type=style&index=0&id=62940214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62940214",
  null
  
)

export default component.exports